import { useMemo } from 'react';

import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import { selectedGradeSelector } from '@/Module/Grade/Store/Selector/findGradeSelector';
import { useAppSelector } from '@/Module/Store/Hook';

export const useLessonPage = () => {
  const grade = useAppSelector(selectedGradeSelector)!;

  const breadcrumb: IBreadcrumbItem[] = useMemo(() => {
    if (!grade) return [];

    if (grade.breadcrumb.length === 2) {
      const [firstGrade, secondGrade] = grade.breadcrumb;

      return [
        {
          key: `GRADE_${firstGrade.entityId}`,
          title: firstGrade.title,
          href: LINKS.GRADE,
        },
        {
          key: `GRADE_${secondGrade.entityId}`,
          title: `پایه ${secondGrade.title}`,
          href: secondGrade.link,
        },
      ];
    }

    if (grade.breadcrumb.length === 3) {
      const [firstGrade, secondGrade, lastGrade] = grade.breadcrumb;

      return [
        {
          key: `GRADE_${firstGrade.entityId}`,
          title: firstGrade.title,
          href: LINKS.GRADE,
        },
        {
          key: `GRADE_${lastGrade.entityId}`,
          title: `پایه ${secondGrade.title} ${lastGrade.title}`,
          href: lastGrade.link,
        },
      ];
    }

    return grade.breadcrumb.map((item, index) => ({
      key: `GRADE_${item.entityId}`,
      title: item.title,
      href: index === 0 ? LINKS.GRADE : item.link,
    }));
  }, [grade]);

  return {
    grade,
    breadcrumb,
  };
};
